  (function () {
    if (window.ndaaCartAttributeInitialized) return;
    window.ndaaCartAttributeInitialized = true;

    const nativeFetch = window.fetch.bind(window);

    let updateTimer = null;
    let updateRunning = false;
    let updatePending = false;

    function getRoot() {
      return window.Shopify?.routes?.root || '/';
    }

    function isCartMutationUrl(url) {
      if (!url) return false;

      return (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      );
    }

    function scheduleNdaaUpdate(delay = 500) {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(function () {
        updateNdaaCartAttribute();
      }, delay);
    }

    async function getProductTags(handle) {
      const root = getRoot();

      const response = await nativeFetch(
        `${root}products/${encodeURIComponent(handle)}.js`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          cache: 'no-store'
        }
      );

      if (!response.ok) {
        console.warn(
          `[NDAA] Could not retrieve product ${handle}:`,
          response.status
        );

        return [];
      }

      const product = await response.json();

      if (Array.isArray(product.tags)) {
        return product.tags;
      }

      return String(product.tags || '')
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
    }

    async function updateNdaaCartAttribute() {
      if (updateRunning) {
        updatePending = true;
        return;
      }

      updateRunning = true;
      updatePending = false;

      try {
        const root = getRoot();

        const cartResponse = await nativeFetch(`${root}cart.js`, {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!cartResponse.ok) {
          throw new Error(
            `Unable to retrieve cart: ${cartResponse.status}`
          );
        }

        const cart = await cartResponse.json();

        const handles = [
          ...new Set(
            cart.items
              .map(function (item) {
                return item.handle;
              })
              .filter(Boolean)
          )
        ];

        let hasNonNdaa = false;

        for (const handle of handles) {
          const tags = await getProductTags(handle);

          const productHasNonNdaa = tags.some(function (tag) {
            return String(tag).trim().toLowerCase() === 'non-ndaa';
          });

          console.log('[NDAA] Product checked:', {
            handle,
            tags,
            productHasNonNdaa
          });

          if (productHasNonNdaa) {
            hasNonNdaa = true;
            break;
          }
        }

        const desiredValue = hasNonNdaa ? 'true' : 'false';

        const currentValue = String(
          cart.attributes?.has_non_ndaa || ''
        )
          .trim()
          .toLowerCase();

        console.log('[NDAA] Cart check:', {
          currentValue,
          desiredValue,
          hasNonNdaa
        });

        if (currentValue === desiredValue) {
          return;
        }

        const updateResponse = await nativeFetch(
          `${root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              attributes: {
                has_non_ndaa: desiredValue
              }
            })
          }
        );

        if (!updateResponse.ok) {
          throw new Error(
            `Unable to update cart attribute: ${updateResponse.status}`
          );
        }

        const updatedCart = await updateResponse.json();

        console.log('[NDAA] Cart attribute saved:', {
          has_non_ndaa:
            updatedCart.attributes?.has_non_ndaa
        });

        document.dispatchEvent(
          new CustomEvent('ndaa:cart-attribute-updated', {
            detail: {
              value: desiredValue,
              hasNonNdaa,
              cart: updatedCart
            }
          })
        );
      } catch (error) {
        console.error(
          '[NDAA] Cart attribute update failed:',
          error
        );
      } finally {
        updateRunning = false;

        if (updatePending) {
          updatePending = false;
          scheduleNdaaUpdate(300);
        }
      }
    }

    /*
     * Watch fetch-based cart requests.
     */
    window.fetch = function (...args) {
      const request = args[0];
      const options = args[1] || {};

      const url =
        typeof request === 'string'
          ? request
          : request?.url || '';

      const requestBody =
        typeof options.body === 'string'
          ? options.body
          : '';

      const isOwnAttributeUpdate =
        url.includes('/cart/update') &&
        requestBody.includes('has_non_ndaa');

      const responsePromise = nativeFetch(...args);

      if (
        isCartMutationUrl(url) &&
        !isOwnAttributeUpdate
      ) {
        responsePromise
          .then(function (response) {
            if (response.ok) {
              /*
               * Give Shopify time to finish updating and rendering
               * the cart before reading /cart.js.
               */
              scheduleNdaaUpdate(600);
            }

            return response;
          })
          .catch(function (error) {
            console.error(
              '[NDAA] Cart request monitoring failed:',
              error
            );
          });
      }

      return responsePromise;
    };

    /*
     * Watch XMLHttpRequest-based cart requests.
     */
    const nativeXhrOpen = XMLHttpRequest.prototype.open;
    const nativeXhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (
      method,
      url,
      ...rest
    ) {
      this._ndaaRequestUrl = String(url || '');

      return nativeXhrOpen.call(
        this,
        method,
        url,
        ...rest
      );
    };

    XMLHttpRequest.prototype.send = function (body) {
      const url = this._ndaaRequestUrl || '';

      const bodyText =
        typeof body === 'string'
          ? body
          : '';

      const isOwnAttributeUpdate =
        url.includes('/cart/update') &&
        bodyText.includes('has_non_ndaa');

      if (
        isCartMutationUrl(url) &&
        !isOwnAttributeUpdate
      ) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 300) {
            scheduleNdaaUpdate(600);
          }
        });
      }

      return nativeXhrSend.call(this, body);
    };

    /*
     * Dawn's publish/subscribe cart event.
     */
    function connectDawnCartEvents() {
      if (
        typeof window.subscribe === 'function' &&
        window.PUB_SUB_EVENTS?.cartUpdate
      ) {
        window.subscribe(
          window.PUB_SUB_EVENTS.cartUpdate,
          function () {
            console.log(
              '[NDAA] Dawn cartUpdate event received'
            );

            scheduleNdaaUpdate(500);
          }
        );

        console.log(
          '[NDAA] Connected to Dawn cartUpdate event'
        );

        return true;
      }

      return false;
    }

    if (!connectDawnCartEvents()) {
      let dawnEventAttempts = 0;

      const dawnEventInterval = setInterval(function () {
        dawnEventAttempts += 1;

        if (
          connectDawnCartEvents() ||
          dawnEventAttempts >= 20
        ) {
          clearInterval(dawnEventInterval);
        }
      }, 500);
    }

    /*
     * Product-form fallback. This catches add-to-cart even if the
     * theme stored its own fetch reference before this script loaded.
     */
    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) {
          return;
        }

        const action = form.getAttribute('action') || '';

        const isProductForm =
          action.includes('/cart/add') ||
          form.querySelector(
            '[name="add"], button[type="submit"][name="add"]'
          );

        if (isProductForm) {
          console.log(
            '[NDAA] Product form submission detected'
          );

          scheduleNdaaUpdate(1000);
        }
      },
      true
    );

    /*
     * Cart quantity and remove controls fallback.
     */
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target.closest(
          [
            'quantity-input button',
            '.quantity__button',
            'cart-remove-button',
            'a[href*="/cart/change"]',
            '[data-cart-remove]',
            '[data-remove-item]'
          ].join(',')
        );

        if (target) {
          console.log(
            '[NDAA] Cart control interaction detected'
          );

          scheduleNdaaUpdate(900);
        }
      },
      true
    );

    /*
     * Common theme-specific events.
     */
    [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'cart-drawer:open',
      'product:added',
      'ajaxProduct:added',
      'ajaxProduct:cartUpdated'
    ].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function () {
          console.log(
            `[NDAA] ${eventName} event received`
          );

          scheduleNdaaUpdate(500);
        }
      );
    });

    /*
     * Run once on initial page load.
     */
    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          scheduleNdaaUpdate(100);
        }
      );
    } else {
      scheduleNdaaUpdate(100);
    }

    /*
     * Manual console test:
     * window.updateNdaaCartAttribute()
     */
    window.updateNdaaCartAttribute =
      updateNdaaCartAttribute;
  })();